import './style.css';
import { useEffect, useState } from 'react';
import ListCard from '../../components/ListCard';
import ListServices from '../../components/ListServices';
import Contact from '../../components/Contact';
import { DESTACADOS } from '../../data/Products';
import { SERVICES } from '../../data/Services';
import { TIPS } from '../../data/Advices.js';

function Home(){
    const [destacado, setDestacado] = useState([]);
    const [services, setServices] = useState([]);
    const [tips, setTips] = useState([]);

    useEffect(()=>{
        setDestacado(DESTACADOS);
        setServices(SERVICES);
        setTips(TIPS);
    }, []);
    
    return <main className="home-container">
        <ListCard title="Destacados" items={destacado} path="productos"/>
        <ListServices items={services}/>       
        <ListCard title="Consejos" items={tips} path="consejos"/>
        <Contact />
    </main>
}

export default Home;